
export class SecurityGrant  {
    id: number = 0;
    securityGroupId: number = 0;
    securityTaskId: number = 0;
    securityTaskCode: string = '';
    grantAdd: boolean|null = null;
    grantActive: boolean = false;
    grantType: boolean = false;
    grantRead: boolean|null = null;
    grantEdit: boolean|null = null;
    grantVoid: boolean|null = null;
    grantDel: boolean|null = null;
    grantPrint: boolean|null = null;
    grantYesNo: boolean|null = null;
    createdBy: string = '';
    createdAt: string | null = null;
    modifiedBy: string = '';
    modifiedAt: string | null = null;

    constructor(init?:Partial<SecurityGrant>) {
		Object.assign(this, init);
	}
}
